const contextActions = Object.freeze({
	UPDATE_FORM_REGISTER: 'UPDATE_FORM_REGISTER',
	UPDATE_MODAL_CONTROLLER: 'UPDATE_MODAL_CONTROLLER',
	CLOSE_MODAL_CONTROLLER: 'CLOSE_MODAL_CONTROLLER',
	SET_LOGIN_USER: 'SET_LOGIN_USER',
	USER_LOGOUT: 'USER_LOGOUT',
	UPDATE_SHOW_FILTERS: 'UPDATE_SHOW_FILTERS',
	SET_PROVINCES: 'SET_PROVINCES',
	SET_ENTITY_TYPES: 'SET_ENTITY_TYPES',
	SET_ROAD_TYPES: 'SET_ROAD_TYPES',
	SET_ADMINISTRATION_LEVELS: 'SET_ADMINISTRATION_LEVELS',
	SET_CUSTOM_NOTIFICATION: 'SET_CUSTOM_NOTIFICATION',
	SET_SERVICE_STATUS: 'SET_SERVICE_STATUS',
	SET_SERVICE_TYPES: 'SET_SERVICE_TYPES',
	SET_USER_TYPES: 'SET_USER_TYPES',
	SET_INIT_LOAD_ERROR: 'SET_INIT_LOAD_ERROR',
	SET_DENY_REASONS: 'SET_DENY_REASONS',
	SET_PERIODICITY_ADVICES: 'SET_PERIODICITY_ADVICES',
	SET_SERVICE_CARDS: 'SET_SERVICE_CARDS',
	UPDATE_NAV_ITEMS: 'UPDATE_NAV_ITEMS',
	SET_INFO_HOME: 'SET_INFO_HOME',
	SET_INDICES_PLUSVALIAS_LISTADO_TAB: 'SET_INDICES_PLUSVALIAS_LISTADO_TAB',
	SET_ADMIN_DATA: 'SET_ADMIN_DATA',
	SET_ESCRITURAS_LISTADO_TAB: 'SET_ESCRITURAS_LISTADO_TAB',
	SET_PLUSVALIAS_INFO_HOME: 'SET_PLUSVALIAS_INFO_HOME',
	SET_ADMIN_USER_CONFIG: 'SET_ADMIN_USER_CONFIG',
	SET_MANAGE_ADMIN_TAB: 'SET_MANAGE_ADMIN_TAB',
	SET_ENCONTRAR_NOTARIO_INFO_HOME: 'SET_ENCONTRAR_NOTARIO_INFO_HOME',
	SET_NOTARIO_TAB: 'SET_NOTARIO_TAB',
	SET_NOTARIO_ACTIVE_TAB: 'SET_NOTARIO_ACTIVE_TAB',
	SET_CURRENT_NOTARIO: 'SET_CURRENT_NOTARIO',
	SET_MARKERS: 'SET_MARKERS',
	SET_NOTARIOS_DATA: 'SET_NOTARIOS_DATA',
	SET_USER_LOCATION: 'SET_USER_LOCATION',
	SET_NOTARIOS_LOCATIONS: 'SET_NOTARIOS_LOCATIONS',
});
export default contextActions;
